package fr.frux.feature.treedetail.identity

import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.runtime.Composable
import fr.frux.core.designsystem.components.SnackbarMessageEffect
import fr.frux.core.designsystem.error.userMessage
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_identity_snackbar_saved
import fr.frux.feature.treedetail.resources.treedetail_identity_snackbar_undo
import fr.frux.feature.treedetail.resources.treedetail_identity_snackbar_undone
import org.jetbrains.compose.resources.stringResource

/**
 * Snackbar du retour d'une correction (canvas `SnackCorrection`). « Annuler » envoie l'inverse
 * avant la consommation : `undo()` lit le message dans l'état, que `consumeMessage()` efface.
 * La consommation se fait à la fin de la snackbar, jamais à son affichage.
 */
@Composable
internal fun IdentityMessageEffect(
    ui: IdentityUi,
    controller: TreeIdentityController,
    snackbarHostState: SnackbarHostState,
) {
    val message = ui.message
    val text =
        when (message) {
            is CorrectionMessage.Saved -> stringResource(Res.string.treedetail_identity_snackbar_saved)
            CorrectionMessage.Undone -> stringResource(Res.string.treedetail_identity_snackbar_undone)
            is CorrectionMessage.UndoFailed -> message.error.userMessage()
            null -> null
        }
    val saved = message is CorrectionMessage.Saved
    SnackbarMessageEffect(
        trigger = message,
        message = text,
        snackbarHostState = snackbarHostState,
        actionLabel = if (saved) stringResource(Res.string.treedetail_identity_snackbar_undo) else null,
        duration = if (saved) SnackbarDuration.Long else SnackbarDuration.Short,
    ) { result ->
        if (result == SnackbarResult.ActionPerformed) controller.undo()
        controller.consumeMessage()
    }
}
